import api from "../../api/organisations.api";
import { sortBy } from "lodash";

const state = {
	organisations: [],
	isFetching: false,
	errorMessage: null
};

const getters = {
	list: (state) => sortBy(state.organisations, ["name"]),
	error: (state): string => state.errorMessage as string,
	fetching: (state): boolean => state.isFetching as boolean
};

const actions = {
	async fetch({ commit }) {
		commit("LOAD_START");
		const orgs = await api.fetch();
		commit(`SET_ORGANISATIONS`, orgs);
		commit(`LOAD_FINISH`);
	}
};

const mutations = {
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	LOAD_FINISH(state: any) {
		state.errorMessage = null;
		state.isFetching = false;
	},
	SET_ORGANISATIONS(state: any, organisations) {
		state.organisations = organisations;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
